import { render, staticRenderFns } from "./UserProfilesModal.vue?vue&type=template&id=71214d76&"
import script from "./UserProfilesModal.vue?vue&type=script&lang=js&"
export * from "./UserProfilesModal.vue?vue&type=script&lang=js&"
import style0 from "./UserProfilesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports